<template>
  <div
    id="invoicesModal"
    class="modal fade"
  >
    <div
      id="print-area-invoices"
      class="modal-dialog modal-full"
    >
      <div
        class="modal-content"
        style="border-style: dashed; border-width: 1px"
      >
        <div class="modal-header">
          <button
            id="close-button-multiple"
            type="button"
            class="close"
            @click="closeModal('invoicesModal'), $emit('close')"
          >
            &times;
          </button>
        </div>
        <table
          cellspacing="0"
          id="head-table"
        >
          <tr>
            <td style="padding-left: 20px">
              <img
                style="width: 110px; height: 100px"
                src="../../../assets/images/black_shipzone.png"
                alt=""
              />
            </td>
            <td>
              <table
                cellspacing="0"
                id="company-info"
                style="width: 100%; margin-left: 0px"
              >
                <tr class="header-table">
                  <td style="font-size: 14px; padding-right: 20px">
                    {{ companyData.company_name }}
                  </td>
                </tr>
                <tr class="header-table">
                  <td style="font-size: 14px; padding-right: 20px">
                    {{ companyData.company_address }}
                  </td>
                </tr>
                <tr class="header-table">
                  <td style="font-size: 14px; padding-right: 20px">
                    {{ companyData.company_email }}
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>

        <div
          class="modal-body"
          v-if="invoicesModal"
        >
          <table
            cellspacing="0"
            style="width: 100%"
            id="print-table1"
          >
            <tr>
              <td id="table-header">
                <h4 style="margin-bottom: 0px">
                  <strong>
                    <span>Shopping Online Invoice</span>
                  </strong>
                </h4>
              </td>
            </tr>
          </table>

          <table
            cellspacing="0"
            style="width: 100%"
          >
            <tr>
              <td class="fm-roboto py-4px px-6px left-border top-border bottom-border">
                <p style="font-size: 15px; font-weight: bold; margin: 0px">
                  Customer Name: <span style="font-weight: normal">{{ invoicesData.customer.full_name }}</span>
                </p>
              </td>
              <td class="fm-roboto py-4px px-6px top-border bottom-border">
                <p style="font-size: 15px; font-weight: bold; margin: 0px">
                  Address:
                  <span style="font-weight: normal">{{ invoicesData.customer.address }}</span>
                </p>
              </td>
              <td class="fm-roboto py-4px px-6px right-border top-border bottom-border">
                <p style="font-size: 15px; font-weight: bold; margin: 0px">
                  Phone:
                  <span style="font-weight: normal">{{ invoicesData.customer.phone_number }}</span>
                </p>
              </td>
            </tr>
          </table>

          <table
            cellspacing="0"
            style="width: 100%"
          >
            <thead>
              <tr>
                <th class="fm-roboto fs-14 bottom-border right-border left-border py-4px px-6px">No.</th>
                <th class="fm-roboto fs-14 bottom-border right-border py-4px px-6px">Product Name</th>
                <th class="fm-roboto fs-14 bottom-border right-border py-4px px-6px">Quantity</th>
                <th class="fm-roboto fs-14 bottom-border right-border py-4px px-6px">Item Price</th>
                <th class="fm-roboto fs-14 bottom-border right-border py-4px px-6px">Invoice No.</th>
                <th class="fm-roboto fs-14 bottom-border right-border py-4px px-6px width-100px">Order No.</th>
                <th class="fm-roboto fs-14 bottom-border right-border py-4px px-6px">Paid</th>
                <th class="fm-roboto fs-14 bottom-border right-border py-4px px-6px">Remain</th>
                <th class="fm-roboto fs-14 bottom-border right-border py-4px px-6px width-100px">Date</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(row, index) in invoicesData.details"
                :key="row.credit_log_transaction_id"
              >
                <td class="fm-roboto fs-14 py-4px px-6px right-border left-border">{{ index + 1 }}</td>
                <td class="fm-roboto fs-14 py-4px px-6px right-border">{{ row.product_name }}</td>
                <td class="fm-roboto fs-14 py-4px px-6px right-border">{{ row.quantity }}</td>
                <td class="fm-roboto fs-14 py-4px px-6px right-border">${{ row.amount }}</td>
                <td class="fm-roboto fs-14 py-4px px-6px right-border">{{ row.invoice_number }}</td>
                <td class="fm-roboto fs-14 py-4px px-6px right-border width-100px">{{ row.theOrderID }}</td>
                <td class="fm-roboto fs-14 py-4px px-6px right-border">${{ row.paid_amount || 0 }}</td>
                <td class="fm-roboto fs-14 py-4px px-6px right-border">${{ (row.amount - Number(row.paid_amount)).toFixed(2) }}</td>
                <td class="fm-roboto fs-14 py-4px px-6px right-border width-100px">{{ row.credit_log_transaction_date }}</td>
              </tr>
            </tbody>
          </table>

          <table
            cellspacing="0"
            style="width: 100%"
          >
          <tr>
              <td class="fm-roboto" style="border: 1px solid #000; text-align: right; padding-right: 10px">
                <p style="font-size: 15px; font-weight: bold; margin: 2px 0px">
                  Sub Total:
                  <span style="font-weight: normal"><b>${{ invoicesData.total_amount.toFixed(2) }}</b></span>
                </p>
                <p
                  style="font-size: 15px; font-weight: bold; margin: 2px 0px"
                >
                  Total Paid:
                  <span style="font-weight: normal"><b>${{ invoicesData.total_paid.toFixed(2) }}</b></span>
                </p>
                <p
                  style="font-size: 15px; font-weight: bold; margin: 2px 0px"
                >
                  Total Remain:
                  <span style="font-weight: normal"><b>${{ invoicesData.total_remain.toFixed(2) }}</b></span>
                </p>
              </td>
            </tr>
            <!-- <tr>
              <td class="fm-roboto" style="border: 1px solid #000; text-align: right; padding-right: 10px">
                <p style="font-size: 15px; font-weight: bold; margin: 2px 0px">
                  Sub Total:
                  <span style="font-weight: normal"><b>${{ invoicesData.total_amount.toFixed(2) }}</b></span>
                </p>
                <p style="font-size: 15px; font-weight: bold; margin: 2px 0px">
                  Customer Credit (Paid):
                  <span style="font-weight: normal"><b>${{ invoicesData.customer.credit }}</b></span>
                </p>
                <p
                  style="font-size: 15px; font-weight: bold; margin: 2px 0px"
                >
                  Total Remain:
                  <span v-if="invoicesData.customer.credit >= 0" style="font-weight: normal">
                    <b>
                      ${{ (invoicesData.total_amount - invoicesData.customer.credit).toFixed(2) }}
                    </b>
                  </span>

                  <span v-else style="font-weight: normal">
                    <b>
                      ${{ invoicesData.customer.credit * -1 }}
                    </b>
                  </span>
                </p>
              </td>
            </tr> -->
          </table>

          <div style="float: right">
            <v-btn
              @click="printInvoiceMultiple"
              id="print-button-multiple"
              style="height: auto"
              outline
              color="primary"
            >Print</v-btn>
          </div>
        </div>

        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['invoicesData', 'closeModal', 'companyData', 'invoicesModal'],

  mounted() {
    let theModal = document.querySelector('.modal')
    theModal.style.overflowX = 'auto'
  },

  methods: {
    printInvoiceMultiple() {
      $('#close-button-multiple').hide()
      $('#print-button-multiple').hide()

      // $('#print-area-invoices').printMe({ path: ['assets/ltr/css/print_style.css'] })
      this.$htmlToPaper('print-area-invoices')
      $('#close-button-multiple').show()
      $('#print-button-multiple').show()
    }
  }
}
</script>

<style>
#print-area-invoices {
  max-width: 900px;
}

/* #print-area-invoices {
  max-width: 850px;
}

.modal {
  text-align: center;
  padding: 0 !important;
}

.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-right: -4px;
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}

@media screen and (max-width: 650px) {
  #table-header {
    width: 500px;
    padding-left: 60px;
  }
  #price-section2 {
    width: 500px;
    padding-left: 10px;
    padding-top: 10px;
    font-size: 15px;
  }
  #price-section {
    width: 280px;
  }
  #company-info {
    margin-left: 0%;
    margin-right: 20px;
    padding: 0px;
  }
  #header-img {
    width: 60px;
    height: 60px;
  }
  #print-area-invoices {
    max-width: 100%;
  }
} */
</style>



// WEBPACK FOOTER //
// src/components/logs/multipleInvoices.vue